import React, { useState, useRef, useEffect } from "react";
import Icon from "./Icon";
import { AllIcons } from "./IconsList";
import Taskbar from "./Taskbar";
import Window from "./Window";
import Folder from "./Folder";
import PDFViewer from "./PdfViewer";
import Video from "./Video";
import TextFile from "./TextFile";
import Browser from "./Browser";
import Image from "./Image";
import StickyNote from "./StickyNote";
import MusicPlayer from "./MusicPlayer";
import SubmitCtf from "./SubmitCtf";
import MorseConverter from "./MorseConverter";
import Calculator from "./Calculator";

//Desktop Backround
import DesktopBackground from "./bgs/bg2.jpg";
//Files Icons
// import FileIcon from "./Icons/file.png";
// import BrowserIcon from "./Icons/browser.png";
// import FolderIcon from "./Icons/folder.png";
// import VideoIcon from "./Icons/video.png";
// import PdfIcon from "./Icons/pdf.png";
// import ImageIcon from "./Icons/image.png";
// import MusicIcon from "./Icons/music.png";
// import CTFIcon from "./Icons/ctf.png";
// import Morseicon from "./Icons/morse_code.png";
// import LinkedIn from "./Icons/linkedin.png";
// import CalculatorIcon from "./Icons/calculator.png";
//Video files
import video_file_source from "./Videos/why_not.mp4";

//Pdf files
import pdf_cv from "./Pdfs/CV_Ali_Bouta.pdf";
import pdf_thesis from "./Pdfs/Masters_Thesis.pdf";
import recommendation_letter_1 from "./Pdfs/Recommendation_Letter_1.pdf";
import recommendation_letter_2 from "./Pdfs/Recommendation_Letter_2.pdf";
import recommendation_letter_3 from "./Pdfs/Recommendation_Letter_3.pdf";

//images
import meme_1 from "./memes/meme-1.png";
import meme_2 from "./memes/meme-2.jpg";
import meme_3 from "./memes/meme-3.jpg";
import tupsu_1 from "./catpics/tupsu1.jpeg";
import tupsu_2 from "./catpics/tupsu2.jpeg";
import tupsu_3 from "./catpics/tupsu3.jpeg";
import kiisumau1 from "./catpics/kiisumau1.jpeg";
import kiisumau2 from "./catpics/kiisumau2.jpeg";
import kiisumau3 from "./catpics/kiisumau3.jpeg";
import kiisumau4 from "./catpics/kiisumau4.jpeg";
import kiisumau5 from "./catpics/kiisumau5.jpeg";
import kiisumau6 from "./catpics/kiisumau6.jpeg";
import kiisumau7 from "./catpics/kiisumau7.jpeg";
import tupsu_and_kiisumau1 from "./catpics/tupsu_and_kiisumau1.jpeg";

//Songs
import Music_1 from "./Music/UP.mp3";
import Music_2 from "./Music/Coolio - Gangsta's Paradise.mp3";

//Audios
import open_app_click from "./Audio/start.mp3";
import windows_startup from "./Audio/startup.mp3";

//font awsome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Desktop() {
  const GRID_SIZE = 90;
  const [desktopSize, setDesktopSize] = useState({ width: 800, height: 600 });
  const [icons, setIcons] = useState(AllIcons);

  const [stickyNotes, setStickyNotes] = useState([
    {
      id: "sticky_1",
      title: "Contact Info",
      content:
        "📞 +32 4 74 79 19 11\n📧 alibouta02@gmail.com\n🏠 Brussels, Belgium",
      position: { x: 1250, y: 135 },
      color: "#FFE4B5", // Light yellow
      zIndex: 100,
      expanded: true,
    },
    {
      id: "sticky_2",
      title: "About Me",
      content:
        "Passionate cybersecurity enthusiast who recently graduated with a masters in IoT CYbersecurity with a background in offensive security, networking, and development.\nI built this portfolio website from scratch, an idea I had years back, and finally made it into reality to showcase my work and growth in the field.",
      position: { x: 1150, y: 55 },
      color: "#FFB6C1", // Light pink
      zIndex: 101,
      expanded: false,
    },
  ]);

  const [openedApps, setOpenedApps] = useState([]);
  const [dragState, setDragState] = useState({});
  const [selectedIcons, setSelectedIcons] = useState(new Set());
  const [selectionBox, setSelectionBox] = useState(null);
  const desktopRef = useRef(null);
  const [openWindows, setOpenWindows] = useState({});
  const [windowZIndex, setWindowZIndex] = useState(200);
  const [folderWindowRefs, setFolderWindowRefs] = useState({});
  const [hoveredFolderId, setHoveredFolderId] = useState(null);
  const [TaskbarFirstTileDown, setTaskbarFirstTileDown] = useState(false);

  // Calculate grid dimensions and absolute positions
  const gridCols = Math.floor(desktopSize.width / GRID_SIZE);
  const gridRows = Math.floor(desktopSize.height / GRID_SIZE);

  const gridToAbsolute = (gridPos) => ({
    x: gridPos.x * GRID_SIZE,
    y: gridPos.y * GRID_SIZE,
  });

  const absoluteToGrid = (absPos) => ({
    x: Math.round(absPos.x / GRID_SIZE),
    y: Math.round(absPos.y / GRID_SIZE),
  });

  const isValidGridPosition = (
    gridPos,
    excludeId = null,
    parentFolder = null,
  ) => {
    const relevantIcons = icons.filter(
      (icon) => icon.parentFolder === parentFolder,
    );
    const containerSize =
      parentFolder === null
        ? { cols: gridCols, rows: gridRows }
        : {
            cols: Math.floor(600 / GRID_SIZE),
            rows: Math.floor(400 / GRID_SIZE),
          }; // Default folder size

    if (
      gridPos.x < 0 ||
      gridPos.y < 0 ||
      gridPos.x >= containerSize.cols ||
      gridPos.y >= containerSize.rows
    ) {
      return false;
    }

    return !relevantIcons.some(
      (icon) =>
        icon.id !== excludeId &&
        icon.gridPosition.x === gridPos.x &&
        icon.gridPosition.y === gridPos.y,
    );
  };

  const handleIconSelect = (
    iconId,
    isMultiSelect = false,
    clearAll = false,
  ) => {
    setSelectedIcons((prev) => {
      const newSelected = new Set(prev);

      if (clearAll) {
        newSelected.clear();
        return newSelected;
      }

      if (!iconId) return newSelected;

      if (isMultiSelect) {
        if (newSelected.has(iconId)) {
          newSelected.delete(iconId);
        } else {
          newSelected.add(iconId);
        }
      } else {
        if (newSelected.has(iconId) && newSelected.size === 1) {
          newSelected.clear();
        } else {
          newSelected.clear();
          newSelected.add(iconId);
        }
      }

      return newSelected;
    });
  };

  const handleDesktopMouseDown = (e) => {
    if (e.target === desktopRef.current) {
      const rect = desktopRef.current.getBoundingClientRect();
      const startPoint = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      };

      setSelectionBox({
        start: startPoint,
        current: startPoint,
      });

      // Clear selection when starting new selection box
      setSelectedIcons(new Set());
    }
  };

  const handleDesktopMouseMove = (e) => {
    if (!selectionBox) return;

    const rect = desktopRef.current.getBoundingClientRect();
    const currentPoint = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };

    setSelectionBox((prev) => ({
      ...prev,
      current: currentPoint,
    }));
  };

  const handleDesktopMouseUp = (e) => {
    if (!selectionBox) return;

    // Calculate which icons are within the selection box
    const boxLeft = Math.min(selectionBox.start.x, selectionBox.current.x);
    const boxRight = Math.max(selectionBox.start.x, selectionBox.current.x);
    const boxTop = Math.min(selectionBox.start.y, selectionBox.current.y);
    const boxBottom = Math.max(selectionBox.start.y, selectionBox.current.y);

    const selectedIconIds = new Set();
    const desktopIcons = icons.filter((icon) => icon.parentFolder === null);

    desktopIcons.forEach((icon) => {
      const iconPos = gridToAbsolute(icon.gridPosition);
      const iconLeft = iconPos.x;
      const iconRight = iconPos.x + GRID_SIZE;
      const iconTop = iconPos.y;
      const iconBottom = iconPos.y + GRID_SIZE;

      // Check if icon overlaps with selection box
      if (
        iconLeft < boxRight &&
        iconRight > boxLeft &&
        iconTop < boxBottom &&
        iconBottom > boxTop
      ) {
        selectedIconIds.add(icon.id);
      }
    });

    setSelectedIcons(selectedIconIds);
    setSelectionBox(null);
  };

  const handleIconPositionChange = (
    iconId,
    action,
    position,
    parentFolder = null,
  ) => {
    setDragState((prev) => {
      const newState = { ...prev };

      switch (action) {
        case "startDrag":
          setSelectedIcons(new Set([iconId]));
          newState[iconId] = { isDragging: true, startPosition: position };
          break;

        case "drag":
          if (newState[iconId]) {
            newState[iconId].currentPosition = position;
          }
          break;

        case "endDrag":
          const targetGrid = absoluteToGrid(position);
          const icon = icons.find((i) => i.id === iconId);
          let currentParent =
            parentFolder !== null ? parentFolder : icon?.parentFolder;

          if (hoveredFolderId) {
            // Find first available grid position in the folder
            const folderCols = Math.floor(600 / GRID_SIZE);
            const folderRows = Math.floor(400 / GRID_SIZE);
            let newGrid = null;
            for (let y = 0; y < folderRows; y++) {
              for (let x = 0; x < folderCols; x++) {
                if (isValidGridPosition({ x, y }, iconId, hoveredFolderId)) {
                  newGrid = { x, y };
                  break;
                }
              }
              if (newGrid) break;
            }
            if (newGrid) {
              setIcons((prevIcons) =>
                prevIcons.map((icon) =>
                  icon.id === iconId
                    ? {
                        ...icon,
                        gridPosition: newGrid,
                        parentFolder: hoveredFolderId,
                      }
                    : icon,
                ),
              );
            }
          } else {
            // Dropped on desktop
            const targetGrid = absoluteToGrid(position);
            let newGrid = null;
            if (isValidGridPosition(targetGrid, iconId, null)) {
              newGrid = targetGrid;
            } else {
              // Fallback: find first available grid cell
              for (let y = 0; y < gridRows; y++) {
                for (let x = 0; x < gridCols; x++) {
                  if (isValidGridPosition({ x, y }, iconId, null)) {
                    newGrid = { x, y };
                    break;
                  }
                }
                if (newGrid) break;
              }
            }
            if (newGrid) {
              setIcons((prevIcons) =>
                prevIcons.map((icon) =>
                  icon.id === iconId
                    ? {
                        ...icon,
                        gridPosition: newGrid,
                        parentFolder: null, // Move to desktop
                      }
                    : icon,
                ),
              );
            }
          }
          // Clear drag state
          delete newState[iconId];
          break;
      }

      return newState;
    });
  };

  //handler functions for sticky notes

  const handleStickyNotePositionChange = (id, newPosition) => {
    setStickyNotes((prev) =>
      prev.map((note) =>
        note.id === id ? { ...note, position: newPosition } : note,
      ),
    );
  };

  const handleStickyNoteContentChange = (id, newTitle, newContent) => {
    setStickyNotes((prev) =>
      prev.map((note) =>
        note.id === id
          ? { ...note, title: newTitle, content: newContent }
          : note,
      ),
    );
  };
  //function to create new sticky notes
  const createNewStickyNote = () => {
    const newNote = {
      id: `sticky_${Date.now()}`,
      title: "New Note",
      content: "Click to edit this note...",
      position: {
        x: Math.random() * (window.innerWidth - 250),
        y: Math.random() * (window.innerHeight - 300),
      },
      color: ["#FFE4B5", "#FFB6C1", "#E0E6FF", "#F0FFF0", "#FFF8DC"][
        Math.floor(Math.random() * 5)
      ],
    };

    setStickyNotes((prev) => [...prev, newNote]);
  };

  //function to bring a sticky note to front of other sticky notes (but still under windows)
  const bringStickyNoteToFront = (id) => {
    setStickyNotes((prev) => {
      const maxStickyZIndex = Math.max(
        ...prev.map((note) => note.zIndex || 100),
      );
      return prev.map((note) =>
        note.id === id
          ? { ...note, zIndex: Math.min(maxStickyZIndex + 1, 149) } // Cap at 149 to stay under windows
          : note,
      );
    });
  };

  useEffect(() => {
    // Update content for all open folder windows when icons change
    Object.values(openWindows).forEach((window) => {
      const icon = icons.find((i) => i.id === window.id && i.file_type === "d");
      if (icon) {
        setOpenWindows((prev) => ({
          ...prev,
          [window.id]: {
            ...prev[window.id],
            content: (
              <Folder
                folderId={icon.id}
                folderName={icon.file_name}
                icons={icons}
                onIconPositionChange={handleIconPositionChange}
                onIconSelect={handleIconSelect}
                onIconDoubleClick={handleIconDoubleClick}
                onMoveIconToFolder={handleMoveIconToFolder}
                selectedIcons={selectedIcons}
                dragState={dragState}
                windowSize={
                  prev[window.id]?.initialSize || { width: 600, height: 400 }
                }
              />
            ),
          },
        }));
      }
    });
    // eslint-disable-next-line
  }, [icons]);

  //handle dropping the icon into a folder when dragging
  useEffect(() => {
    const handleMouseMove = (e) => {
      const draggingIconId = Object.keys(dragState).find(
        (id) => dragState[id].isDragging,
      );
      if (!draggingIconId) {
        setHoveredFolderId(null);
        return;
      }

      let foundHover = null;
      Object.entries(folderWindowRefs).forEach(([folderId, ref]) => {
        if (ref.current) {
          const rect = ref.current.getBoundingClientRect();
          if (
            e.clientX >= rect.left &&
            e.clientX <= rect.right &&
            e.clientY >= rect.top &&
            e.clientY <= rect.bottom
          ) {
            foundHover = folderId;
          }
        }
      });
      setHoveredFolderId(foundHover);
    };

    document.addEventListener("mousemove", handleMouseMove);
    return () => document.removeEventListener("mousemove", handleMouseMove);
  }, [dragState, folderWindowRefs]);

  const handleMoveIconToFolder = (iconId, targetFolderId, newGridPosition) => {
    setIcons((prevIcons) =>
      prevIcons.map((icon) =>
        icon.id === iconId
          ? {
              ...icon,
              parentFolder: targetFolderId,
              gridPosition: newGridPosition,
            }
          : icon,
      ),
    );
  };

  const handleMoveIconToDesktop = (iconId, newGridPosition) => {
    setIcons((prevIcons) =>
      prevIcons.map((icon) =>
        icon.id === iconId
          ? { ...icon, parentFolder: null, gridPosition: newGridPosition }
          : icon,
      ),
    );
  };

  // Update desktop size on mount and resize
  useEffect(() => {
    const updateSize = () => {
      if (desktopRef.current) {
        const rect = desktopRef.current.getBoundingClientRect();
        setDesktopSize({ width: rect.width, height: rect.height });
      }
    };

    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  // Add selection box event listeners
  useEffect(() => {
    if (selectionBox) {
      document.addEventListener("mousemove", handleDesktopMouseMove);
      document.addEventListener("mouseup", handleDesktopMouseUp);
      return () => {
        document.removeEventListener("mousemove", handleDesktopMouseMove);
        document.removeEventListener("mouseup", handleDesktopMouseUp);
      };
    }
  }, [selectionBox, icons]);

  //function to make taskbar go down after 10 seconds of loading the page
  useEffect(() => {
    const timer = setTimeout(() => {
      setTaskbarFirstTileDown(true);
    }, 8423); //the taskbar will go down after 8 seconds and 423 milliseconds because why not!!!

    return () => clearTimeout(timer);
  }, []);

  //function to open an app (call this when an icon is double-clicked)
  const openApp = (icon) => {
    setOpenedApps((prev) => {
      // Prevent duplicates
      if (prev.some((app) => app.id === icon.id)) return prev;
      return [...prev, icon];
    });
  };

  //window opening and handling functions
  const openWindow = (iconId, windowConfig) => {
    setOpenWindows((prev) => ({
      ...prev,
      [iconId]: {
        id: iconId,
        isOpen: true,
        isMinimized: false,
        zIndex: windowZIndex,
        ...windowConfig,
      },
    }));
    setWindowZIndex((prev) => prev + 10);
  };

  const closeWindow = (windowId) => {
    setOpenWindows((prev) => {
      const newWindows = { ...prev };
      delete newWindows[windowId];
      return newWindows;
    });
  };

  const minimizeWindow = (windowId) => {
    setOpenWindows((prev) => ({
      ...prev,
      [windowId]: {
        ...prev[windowId],
        isMinimized: true,
      },
    }));
  };

  const restoreWindow = (windowId) => {
    setOpenWindows((prev) => ({
      ...prev,
      [windowId]: {
        ...prev[windowId],
        isMinimized: false,
        zIndex: windowZIndex,
      },
    }));
    setWindowZIndex((prev) => prev + 1);
  };

  const focusWindow = (windowId) => {
    setOpenWindows((prev) => ({
      ...prev,
      [windowId]: {
        ...prev[windowId],
        zIndex: windowZIndex,
      },
    }));

    setWindowZIndex((prev) => prev + 5);
  };

  // NEW: Handle taskbar icon clicks
  const handleTaskbarIconClick = (iconId) => {
    const window = openWindows[iconId];
    if (!window) return;

    if (window.isMinimized) {
      // If window is minimized, restore it
      restoreWindow(iconId);
    } else {
      // If window is visible, either focus it or minimize it
      if (
        window.zIndex ===
        Math.max(...Object.values(openWindows).map((w) => w.zIndex))
      ) {
        // If it's already the top window, minimize it
        minimizeWindow(iconId);
      } else {
        // If it's not on top, focus it
        focusWindow(iconId);
      }
    }
  };

  const handleIconDoubleClick = (iconId) => {
    const icon = icons.find((i) => i.id === iconId);
    let window_height = 400;
    let window_width = 600;
    let isImage = false;
    if (icon) {
      // Define different window content based on icon type
      let windowContent = <div>Default content for {icon.file_name}</div>;
      const open_app_sound = new Audio(open_app_click);
      open_app_sound
        .play()
        .catch((err) => console.log("Audio playback failed:", err));

      switch (icon.file_type) {
        case "tf":
          windowContent = (
            <div
              style={{
                position: "relative",
                height: "100%",
              }}
            >
              {icon.content}
            </div>
          );
          break;
        case "b":
          windowContent = icon.content; //<div>Browser content goes here</div>;
          break;
        case "t":
          windowContent = <div>Terminal content goes here</div>;
          break;
        case "d":
          // Folder content
          windowContent = (
            <Folder
              onDragEnter={(e) => {
                e.prevenDefault();
                e.stopPropagate();
                console.log("hi");
              }}
              folderId={iconId}
              folderName={icon.file_name}
              icons={icons}
              onIconPositionChange={handleIconPositionChange}
              onIconSelect={handleIconSelect}
              onIconDoubleClick={handleIconDoubleClick}
              onMoveIconToFolder={handleMoveIconToFolder}
              selectedIcons={selectedIcons}
              dragState={dragState}
              windowSize={
                openWindows[iconId]?.initialSize || { width: 600, height: 400 }
              }
            />
          );
          break;
        case "v":
          windowContent = icon.content;
          break;
        case "i":
          windowContent = (
            <div style={{ position: "relative", height: "100%" }}>
              <Image
                src={icon.src} // Sample image URL
                alt={icon.alt}
                fileName={icon.file_name}
                parentFolder={icon.parentFolder}
              />
            </div>
          );
          isImage = true;
          break;
        case "p":
          windowContent = <div>{icon.content}</div>;
          break;
        case "ctf":
          windowContent = (
            <div style={{ position: "relative", height: "100%" }}>
              {icon.content}
            </div>
          );
          break;
        case "calc":
          window_height = 540;
          window_width = 300;
          windowContent = (
            <div style={{ position: "relative", height: "100%" }}>
              {icon.content}
            </div>
          );
          break;
        case "m":
          windowContent = (
            <div
              style={{
                position: "relative",
                height: "100%",
                overflow: "hidden",
                backgroundColor: "rgba(15, 12, 41, 0)",
              }}
            >
              <MusicPlayer
                src={icon.content}
                fileName={icon.file_name}
                autoPlay={false}
              />
            </div>
          );
          break;
        case "linkedin":
          window
            .open("https://www.linkedin.com/in/ali-bouta", "_blank")
            .focus();
          windowContent = (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 20,
                backgroundImage:
                  "linear-gradient( 109.6deg,  rgba(33,99,255,1) 11.2%, rgba(0,10,139,1) 100.2% )",
              }}
            >
              <iframe
                src="https://www.linkedin.com/embed/feed/update/urn:li:share:7364073994213281792"
                height="1026"
                width="450"
                frameborder="0"
                allowfullscreen=""
                title="My Latest Internship"
              ></iframe>
            </div>
          );
          break;
        default:
          windowContent = (
            <div
              style={{
                position: "relative",
                height: "100%",
                backgroundColor: "transparent",
              }}
            >
              {icon.content}
            </div>
          );
      }

      openWindow(iconId, {
        title: isImage ? "Picture" : icon.file_name,
        content: windowContent,
        initialPosition: {
          x: 150 + Math.random() * 100,
          y: 100 + Math.random() * 100,
        },
        initialSize: { width: window_width, height: window_height },
      });
      isImage = false;
    }
  };

  // Filter icons to show only those on desktop (parentFolder === null)
  const desktopIcons = icons.filter((icon) => icon.parentFolder === null);

  useEffect(() => {
    const startup_sound_play = new Audio(windows_startup);
    startup_sound_play.volume = 0.7; //sound is 70% of original volume
    startup_sound_play
      .play()
      .catch((err) => console.log("Audio playback failed for somereason", err));
  }, []);

  return (
    <div
      ref={desktopRef}
      className="desktop"
      onMouseDown={handleDesktopMouseDown}
      style={{
        width: "100vw",
        height: "100vh",
        backgroundImage: `url(${DesktopBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Selection Box */}
      {selectionBox && (
        <div
          style={{
            position: "absolute",
            left: `${Math.min(selectionBox.start.x, selectionBox.current.x)}px`,
            top: `${Math.min(selectionBox.start.y, selectionBox.current.y)}px`,
            width: `${Math.abs(
              selectionBox.current.x - selectionBox.start.x,
            )}px`,
            height: `${Math.abs(
              selectionBox.current.y - selectionBox.start.y,
            )}px`,
            backgroundColor: "rgba(0, 123, 255, 0.2)",
            border: "1px solid #007bff",
            pointerEvents: "none",
            zIndex: 999,
          }}
        />
      )}

      {/* Desktop Icons (only icons with parentFolder === null) */}
      {desktopIcons.map((icon) => {
        const dragInfo = dragState[icon.id];
        const absolutePos =
          dragInfo?.isDragging && dragInfo.currentPosition
            ? dragInfo.currentPosition
            : gridToAbsolute(icon.gridPosition);

        return (
          <Icon
            key={icon.id}
            id={icon.id}
            file_name={icon.file_name}
            icon_source={icon.icon_source}
            gridPosition={icon.gridPosition}
            absolutePosition={absolutePos}
            isDragging={dragInfo?.isDragging || false}
            isSelected={selectedIcons.has(icon.id)}
            onPositionChange={handleIconPositionChange}
            onSelect={handleIconSelect}
            onOpen={() => openApp(icon)}
            onDoubleClick={handleIconDoubleClick}
            parentFolder={null}
            onMoveIconToFolder={handleMoveIconToFolder}
            getContainerRect={() => desktopRef.current.getBoundingClientRect()}
          />
        );
      })}

      {/* Render open windows */}
      {Object.values(openWindows).map((window) => {
        const isFolder =
          icons.find((i) => i.id === window.id)?.file_type === "d";
        let ref = null;
        if (isFolder) {
          ref = folderWindowRefs[window.id] || React.createRef();
          if (!folderWindowRefs[window.id]) {
            setFolderWindowRefs((prev) => ({ ...prev, [window.id]: ref }));
          }
        }
        return (
          <Window
            key={window.id}
            ref={isFolder ? ref : undefined}
            id={window.id}
            title={window.title}
            isOpen={window.isOpen}
            isMinimized={window.isMinimized}
            zIndex={window.zIndex}
            initialPosition={window.initialPosition}
            initialSize={window.initialSize}
            onClose={closeWindow}
            onMinimize={minimizeWindow}
            onRestore={restoreWindow}
            onFocus={focusWindow}
          >
            {window.content}
          </Window>
        );
      })}
      {/* Sticky Notes */}
      {stickyNotes.map((note) => (
        <StickyNote
          key={note.id}
          id={note.id}
          title={note.title}
          content={note.content}
          initialPosition={note.position}
          color={note.color}
          onPositionChange={handleStickyNotePositionChange}
          onContentChange={handleStickyNoteContentChange}
          baseZIndex={note.zIndex || 100}
          onFocus={() => bringStickyNoteToFront(note.id)} // Bring to front when focused
          ExpanState={note.expanded}
        />
      ))}
      {/* FIXED: Pass openWindows and click handler to Taskbar */}
      <Taskbar
        isTaskbarFirstTileDown={TaskbarFirstTileDown}
        openWindows={openWindows}
        icons={icons}
        onIconClick={handleTaskbarIconClick}
      />
    </div>
  );
}

export default Desktop;
